import { MakeAPaymentFormValues } from './types';

export const makeAPaymentDataKeys: { [K in keyof MakeAPaymentFormValues]: K } = {
    firstName: 'firstName',
    lastName: 'lastName',
    email: 'email',
    location: 'location',
    room: 'room',
    academicYear: 'academicYear',
    amount: 'amount',
    vitaRef: 'vitaRef',
};

export enum SpanishBuildings {
    PEDRALBES = 'Vita Student Pedralbes',
    POBLENOU = 'Vita Student Poblenou',
}
